import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from '@reach/router'

// icons
import { Barcode } from '@styled-icons/boxicons-regular/Barcode'
import { PeopleFill } from '@styled-icons/bootstrap'
import { Settings } from 'styled-icons/ionicons-outline'
// import { Team } from '@styled-icons/remix-fill'

// utils
import th from 'utils/themeHelper'

// styles
import DashCardWrapper from './DashCardWrapper'

import { FileInvoiceDollar } from '@styled-icons/fa-solid/FileInvoiceDollar'
import { AdminPanelSettings } from '@styled-icons/material/AdminPanelSettings'
import { PeopleFill as People, Receipt } from '@styled-icons/bootstrap'
import { BuildingHouse } from '@styled-icons/boxicons-regular/BuildingHouse'
import { Handshake } from '@styled-icons/fa-solid/Handshake'

const baseIconStyles = css`
  background: ${props => props.background};
  border-radius: ${props => (props.background ? '50%' : '0')};
  color: ${th('borders.dark')};
  height: 20px;
  padding: 2px;
  width: 20px;
`

const AdminPanelIcon = styled(AdminPanelSettings)`
  ${baseIconStyles}
`

const BuildingHouseIcon = styled(BuildingHouse)`
  ${baseIconStyles}
`

const FileInvoice = styled(FileInvoiceDollar)`
  ${baseIconStyles}
`

const HandshakeIcon = styled(Handshake)`
  ${baseIconStyles}
`

const PeopleIcon = styled(People)`
  ${baseIconStyles}
`

const ReceiptIcon = styled(Receipt)`
  ${baseIconStyles}
`

const ActionItem = styled.div`
  margin-right: 10px;
  margin-top: 15px;

  &:last-of-type {
    margin-right: 0;
  }
`

const Actions = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 10px;
`

const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const TeamCardLink = styled(Link)`
  border-color: ${th('backgrounds.mid')};
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  color: ${th('text.dark')};
  margin: 0;
  padding: 8px 12px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;

  & > svg {
    width: 15px;
    margin-right: 10px;
  }

  @media screen and (max-width: 400px) {
    padding: 6px 8px;
    font-size: 12px;

    & > svg {
      width: 12px;
      margin-right: 6px;
    }
  }
`

const Info = styled.div`
  display: block;
  margin: 10px 15px 0;
  flex: 1;
`

const InfoFieldLabel = styled.div`
  font-family: ${th('fonts.bold')};
  margin-right: 10px;
`

const InfoFieldValue = styled.div`
  font-family: ${th('fonts.regular')};
  margin-left: 30px;
`

const InfoFieldIcon = styled.div`
  margin-right: 10px;

  & > svg {
    height: 20px;
  }
`

const InfoGroup = styled.div`
  min-width: 30%;
`

const InfoGroupRow = styled.div`
  color: ${th('text.mid')};
  line-height: 1.25em;
  margin-bottom: 15px;
`

const InfoGroupRowInner = styled.div`
  display: flex;
  word-break: break-word;
`

const DashWorkspaceCard = ({
  id,
  outputs_enabled,
  participant_management_enabled,
  payroll_enabled,
  partners_count,
  purchase_requests_enabled,
  partner_admins,
  workspace_name,
  workspace_admins
}) => {
  return (
    <DashCardWrapper>
      <ActionsWrapper>
        <Info>
          <InfoGroup>
            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <Barcode />
                </InfoFieldIcon>
                <InfoFieldLabel>Workspace</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{workspace_name}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <AdminPanelIcon background="gold" />
                </InfoFieldIcon>
                <InfoFieldLabel>Workspace Admins</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{workspace_admins}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <AdminPanelIcon background="#379b7550" />
                </InfoFieldIcon>
                <InfoFieldLabel>Partner Admins</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{partner_admins}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <BuildingHouseIcon />
                </InfoFieldIcon>
                <InfoFieldLabel>Outputs enabled</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{outputs_enabled}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <PeopleIcon />
                </InfoFieldIcon>
                <InfoFieldLabel>Participants enabled</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{participant_management_enabled}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <ReceiptIcon />
                </InfoFieldIcon>
                <InfoFieldLabel>Purchases enabled</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{purchase_requests_enabled}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <FileInvoice />
                </InfoFieldIcon>
                <InfoFieldLabel>Payroll enabled</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{payroll_enabled}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <HandshakeIcon />
                </InfoFieldIcon>
                <InfoFieldLabel>Partners</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{partners_count}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>
          </InfoGroup>
        </Info>

        <Actions>
          <ActionItem>
            <TeamCardLink to={`/dashboard/admins?workspaceId=${id}`}>
              <PeopleFill />
              <span>Admins</span>
            </TeamCardLink>
          </ActionItem>

          <ActionItem>
            <TeamCardLink to={`/dashboard/workspaces/${id}`}>
              <Settings />
              <span>Manage workspace</span>
            </TeamCardLink>
          </ActionItem>
        </Actions>
      </ActionsWrapper>
    </DashCardWrapper>
  )
}

export default DashWorkspaceCard
